import React from 'react';
import { CardContainer, PointsContainer, PointsText } from './styles';
import Text from '../../../components/Text';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import trophy from './assets/trophy.svg';

function CardPoints({ user, points }) {
  return (
    <CardContainer>
      <Row>
        <Col xs={12} md={4} className="d-flex align-items-center">
          <PointsContainer className="align-self-center">
            <img src={trophy} alt="Trophy" width="80px" />
            <Text color="#fff" type="body">
              Fidelidade
            </Text>
          </PointsContainer>
        </Col>
        <Col xs={12} md={8} className="d-flex align-items-center">
          <PointsContainer>
            <Text color="#fff" type="body">
              {user?.username || 'Usuário não encontrado'}
            </Text>
            <PointsText color="#fff" type="subtitle">
              {points} pontos
            </PointsText>
          </PointsContainer>
        </Col>
      </Row>
    </CardContainer>
  );
}

export default CardPoints;
